import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import Store from 'store/store';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

	checkIfLoaded() {
		if (this.loadcheckPassedElsewhere) return true;
		const usualChecks = this.state.isComponentLoaded && (this.state.bgImageLoaded || !this.backgroundData);
		const memeGenStore = Store.get()?.memeGenerator || {};
		const activePageNotMemeGen = this.state?.appState?.activePage !== 'memeGenerator';
		const canLoadWithMemeGen = activePageNotMemeGen || memeGenStore.scrolled;
		const loaded = usualChecks && canLoadWithMemeGen;
		if (loaded && activePageNotMemeGen) {
			this.loadcheckPassedElsewhere = true;
		}
		return loaded;
	}

}
